export default __webpack_public_path__ + "static/media/UP3_icon.aa4f0afd.svg";